
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  data() {
    const page = (this as Vue & { page?: number }).page;
    return { insertedPageNumber: page ?? 1 };
  }
})
export default class BasePagination extends Vue {
  @Prop(Number) public page!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Number) public perPage!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;

  public insertedPageNumber!: number;

  @Watch('page')
  onPageChange(val: number) {
    this.insertedPageNumber = val ?? 1;
  }
}
